import { render, staticRenderFns } from "./BottomBar.vue?vue&type=template&id=3780e6a7&scoped=true&"
import script from "./BottomBar.vue?vue&type=script&lang=js&"
export * from "./BottomBar.vue?vue&type=script&lang=js&"
import style0 from "./BottomBar.vue?vue&type=style&index=0&id=3780e6a7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3780e6a7",
  null
  
)

export default component.exports